import copy from "copy-to-clipboard";
import { useEffect, useState } from "react";

interface IOptions {
  interval?: number;
}

const useCopyToClipboard = (
  text: string,
  options?: IOptions,
): [boolean, () => void] => {
  const [isCopied, setIsCopied] = useState(false);
  const successDuration = options && options.interval;

  useEffect(() => {
    let timeout;
    if (isCopied && successDuration) {
      timeout = setTimeout(() => {
        setIsCopied(false);
      }, successDuration);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [isCopied, successDuration]);

  return [
    isCopied,
    () => {
      void copy(text).then(setIsCopied);
    },
  ];
};

export default useCopyToClipboard;
